/**
 * User Helper Composable
 * Provides consistent access to user ID across client and server
 */
export function useUser() {
  const supabaseUser = useSupabaseUser()

  /**
   * Get the current user's ID
   * Handles both old (id) and new (sub) Supabase user object formats
   */
  const userId = computed(() => {
    if (!supabaseUser.value)
      return null

    // Try id first (older Supabase versions), fallback to sub (JWT standard)
    const user = supabaseUser.value as { id?: string, sub?: string }

    return user.id || user.sub || null
  })

  /**
   * Check if user is authenticated
   */
  const isAuthenticated = computed(() => !!supabaseUser.value)

  return {
    user: supabaseUser,
    userId,
    isAuthenticated,
  }
}
